<template>
    <div class="page-content">
        <UserHeadline title="Signups.title" />
        <template v-if="!isLoadingData">
            <template v-if="filterPastAndCancelledEvents.length > 0">
                <TotemButton
                    color="primary"
                    @click="goToDigitalClassrooms"
                    :label="$t('DigitalClassrooms.sign_up_for_digital_classrooms')"
                    icon="arrow-right"
                    iconPosition="right"
                    maxContentWidth="true"
                    class="page-content__sign-up-button"
                />
                <h2 class="page-content__subtitle" v-html="$t('DigitalClassrooms.upcoming')"></h2>
                <DigitalClassRoomTable>
                    <DigitalClassRoomEvent
                        v-for="(event, index) in filterPastAndCancelledEvents"
                        :key="index"
                        :event="event"
                        :course="event.course"
                    >
                    </DigitalClassRoomEvent>
                </DigitalClassRoomTable>
            </template>
            <EmptyStateNotification
                v-else
                :content="$t('DigitalClassrooms.you_dont_have_any_signups')"
                :hint="$t('DigitalClassrooms.no_signups_hint')"
            >
                <TotemButton
                    color="primary"
                    @click="goToDigitalClassrooms"
                    :label="$t('DigitalClassrooms.sign_up_for_digital_classrooms')"
                    icon="arrow-right"
                    iconPosition="right"
                    maxContentWidth="true"
                />
            </EmptyStateNotification>
            <template v-if="getPastEvents.length > 0">
                <h1 class="page-content__subtitle" v-html="$t('DigitalClassrooms.past_signups_title')"></h1>
                <DigitalClassRoomTable :pastEventsTable="true">
                    <DigitalClassRoomEvent
                        v-for="(event, index) in getPastEvents"
                        :key="index"
                        :event="event"
                        :course="event.course"
                        :isPastEvent="true"
                    >
                    </DigitalClassRoomEvent>
                </DigitalClassRoomTable>
            </template>
        </template>
        <div v-else class="digital-classrooms-signup__loader">
            <span class="spinner icon-spinner digital-classrooms-signup__spinner"></span>
        </div>
        <TotemToast ref="toast"/>
    </div>
</template>

<script>
    import UserHeadline from 'components/user/UserHeadline'
    import routeHelper from 'components/shared/mixins/routeHelper'
    import DigitalClassRoomEvent from 'components/user/signups/DigitalClassRoomEvent'
    import DigitalClassRoomTable from 'components/user/signups/DigitalClassRoomTable'
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    import EmptyStateNotification from 'components/user/shared/EmptyStateNotification'

    export default {
        name: 'DigitalClassRoomSignUps',
        mixins: [ routeHelper ],
        components: {
            UserHeadline,
            DigitalClassRoomEvent,
            DigitalClassRoomTable,
            EmptyStateNotification
        },
        props: {
            course: Object
        },
        computed: {
            ...mapGetters({
                signedUpEvents: 'Courses/getSignedUpEventsForUser',
                getCourseById: 'Courses/getCourseById'
            }),
            getSignUpsCourseData () {
                return this.signedUpEvents.map(event => ({ ...event.training, subscriptionId: event.id, status: event.subscriptionStatus }))
            },
            filterPastAndCancelledEvents () {
                return this.getSignUpsCourseData.filter(event =>
                    moment(event.sessions[event.sessions.length - 1].endDateAndTime).unix() > moment().unix() &&
                    event.status !== 'cancelled' && event.status !== 'pending').sort(function (a, b) {
                    return new Date(a.firstTrainingDateAndTime) - new Date(b.firstTrainingDateAndTime)
                })
            },
            getPastEvents () {
                return this.getSignUpsCourseData.filter(event =>
                    moment().unix() > moment(event.sessions[event.sessions.length - 1].endDateAndTime).unix() &&
                    event.status !== 'cancelled' && event.status !== 'pending')
                    .sort(function (a, b) {
                        return new Date(a.firstTrainingDateAndTime) - new Date(b.firstTrainingDateAndTime)
                    })
            },
        },
        data () {
            return {
                isLoadingData: false
            }
        },
        methods: {
            goToDigitalClassrooms () {
                this.$router.push({ name: 'all-packages-virtual-classrooms' })
            },
        },
        async created () {
            try {
                this.isLoadingData = true
                await this.$store.dispatch('Courses/loadSignedUpEvents')
            } catch (error) {
            } finally {
                this.isLoadingData = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-content {
        &__subtitle {
            font-family: PlusJakartaSans-Medium, sans-serif;
            color: $tuatara;
            font-size: 2.2rem;
            margin: 0 0 20px;
        }

        &__sign-up-button {
            margin: 30px 0;

            [class*="desktop"] {
                margin: 0 0 40px;
            }
        }

        .digital-classrooms-signup {
            margin: 0 0 40px;

            &__table {
                display: flex;
                flex-direction: column;
                overflow: hidden;
                border: solid 1px $wild_sand;
            }

            &__no-sign-ups {
                margin: 0 0 40px;
            }
        }
    }

    @include digital-classrooms-table;
</style>
